export const COMMENTS_STATE_INITIAL = 'COMMENTS_STATE_INITIAL';
export const COMMENTS_STATE_CREATE = 'COMMENTS_STATE_CREATE';
export const COMMENTS_STATE_EDIT = 'COMMENTS_STATE_EDIT';
export const COMMENTS_STATE_DELETE = 'COMMENTS_STATE_DELETE';
export const COMMENTS_PARENT_STATE_DELETE = 'COMMENTS_PARENT_STATE_DELETE';
export const COMMENTS_STATE_REPLY = 'COMMENTS_STATE_REPLY';

export const ENUMS_COMMENT_STATES = [
  COMMENTS_STATE_INITIAL,
  COMMENTS_STATE_CREATE,
  COMMENTS_STATE_EDIT,
  COMMENTS_STATE_DELETE,
  COMMENTS_PARENT_STATE_DELETE,
  COMMENTS_STATE_REPLY,
];

export const STATUS_DELETED = 'DELETED';
export const STATUS_PARENT_DELETED = 'PARENT_DELETED';
export const STATUS_ACTIVE = 'ACTIVE';
export const STATUS_WAIT_SERVER_APPROVE = 'WAIT_SERVER_APPROVE';

export const ENUMS_COMMENTS = [STATUS_DELETED, STATUS_PARENT_DELETED, STATUS_ACTIVE, STATUS_WAIT_SERVER_APPROVE];
